import { CountryData } from '@/components/NameCheck/nameCheck';
import { request } from '@/utils/request';

export async function queryCountries(): Promise<CountryData[]> {
  const data = await request<CountryData[]>('/countries/countries-code', { method: 'GET' });
  return data;
}
